import { IRequestData } from 'src/dal/modules/RequestFetcher/RequestFetcher.typed';
import { IRequestHandlerOptions, RequestModelHandler } from '../RequestModel/RequestModel.typed';
import { customFetch } from '../../customFetch/customFetch';

/**
 * Функция высшего порядка: принимает обработчик модели запроса (формирует URL и параметры)
 * и возвращает типизированный асинхронный fetcher.
 */
export const createRequestFetcher =
  <GResponseData = unknown, GRequestData = IRequestData>(requestModelHandler: RequestModelHandler) =>
  async (params?: IRequestHandlerOptions<GRequestData>): Promise<GResponseData> => {
    const { url, requestInit } = requestModelHandler({ ...params });

    return customFetch<GResponseData>(url, requestInit);
  };
